import { EstimateIntervalData } from "@/components/shared/interval-switch/estimate-interval-change";

/** The first valid coupon on the estimate; the code the switch sends and tracks. */
export function getAppliedPromoCode(
  discounts: EstimateIntervalData["discounts"] = [],
): string | undefined {
  return discounts.find((discount) => !discount.invalid)?.coupon_code;
}
